import React, { useMemo, useState, useEffect } from "react";

const POOL_META = [
  { key: "opening", title: "Vibe" },
  { key: "occasion", title: "Perfect for" },
  { key: "pairing", title: "Pairs well with" },
  { key: "care", title: "Wear & rental care" },
];

/** Styled like DB pools — only pairing / occasion / silhouette (no logistics or rental-policy copy). */
const FALLBACK_STYLE_TILES = [
  {
    title: "Vibe",
    line:
      "A soft-glam silhouette: let fabric and neckline stay the heroes; keep polish high and clutter low.",
  },
  {
    title: "Perfect for",
    line:
      "Roka or mehendi lunches, intimate dinners, and daytime gatherings where you want to feel dressed but still move easily.",
  },
  {
    title: "Pairs well with",
    line:
      "Warm-toned metallics—antique gold or rose gold—and simple jhumkis or studs so embroidery can breathe.",
  },
  {
    title: "Silhouette & drape",
    line:
      "A neat dupatta pin for mingling/dancing; loosen the fall for seated portraits so the garment photographs full and fluid.",
  },
];

function shuffleCopy(arr) {
  const out = [...arr];
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const t = out[i];
    out[i] = out[j];
    out[j] = t;
  }
  return out;
}

function pickLine(key, snippets) {
  const list = snippets && snippets[key];
  if (!Array.isArray(list) || list.length === 0) return null;
  const i = Math.floor(Math.random() * list.length);
  return String(list[i] || "").trim() || null;
}

export default function AskAISuggestionsModal({ open, onClose, stylingSnippets }) {
  const [seed, setSeed] = useState(0);

  useEffect(() => {
    if (open) setSeed((x) => x + 1);
  }, [open]);

  const bullets = useMemo(() => {
    void seed;
    const hasPool = stylingSnippets
      ? POOL_META.some((p) => {
          const arr = stylingSnippets[p.key];
          return Array.isArray(arr) && arr.some((line) => String(line).trim());
        })
      : false;
    if (hasPool) {
      const items = [];
      for (const { key, title } of POOL_META) {
        const line = pickLine(key, stylingSnippets);
        if (line) items.push({ title, line });
      }
      if (items.length > 0) return items;
    }
    return shuffleCopy(FALLBACK_STYLE_TILES);
  }, [stylingSnippets, seed]);

  if (!open) return null;

  return (
    <div className="productTermsOverlay productAskAiOverlay" onClick={onClose} role="presentation">
      <div
        className="productTermsModal productAskAiModal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="askAiModalTitle"
      >
        <div className="productAskAiAccent" aria-hidden />

        <button
          type="button"
          className="productTermsModalClose productAskAiClose"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>

        <div className="productAskAiBody">
          <header className="productAskAiHeader">
            <h3 id="askAiModalTitle" className="productAskAiTitle">
              Ask AI
            </h3>
            <p className="productAskAiSubtitle">Styling ideas — pairing, occasion, and wear.</p>
          </header>

          <div className="productAskAiTipsList">
            {bullets.map((b, i) => (
              <article key={`${b.title}-${i}`} className="productAskAiTip">
                <span className="productAskAiTipLabel">{b.title}</span>
                <p className="productAskAiTipText">{b.line}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
